import { unified } from "unified";
import markdown from "remark-parse";
import docx from "remark-docx";
import downloadFile from "./downloadFile";

interface IConvertMarkdownToDocxFileProps {
	text: string;
	filename: string;
}

// функция конвертирования MD разметки в .docx файл
const convertMarkdownToDocxFile = async ({ text, filename }: IConvertMarkdownToDocxFileProps) => {
	const processor = unified()
		.use(markdown)
		.use(docx, {
			output: "blob",
			styles: { default: { document: { run: { font: "Calibri" } } } },
		});
	const doc = await processor.process(text.replace(/\n\n/g, "\n\n&nbsp;\n\n"));
	const blob = await doc.result;
	if (blob instanceof Blob) downloadFile(blob, `${filename}.docx`);
};

export default convertMarkdownToDocxFile;
